import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import SwivuModal from "../../../react/components/editors/SwivuModal.jsx";
import about from "../../../other/data/about.jsx";
import EditorBase from "../base/EditorBase.jsx";
import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import {useCallback} from "react";

class SwivuAbout extends EditorBase {
  static get $name() {
    return "SwivuAbout";
  }

  static get type() {
    return WIDGET_KEYS.aboutModalType;
  }

  static get configurable() {
    return {
      title: "About",
      width: "93em",
      minWidth: "30em",
      maxWidth: "100vw",
      height: "min(100vh, 800px)",
      minHeight: "600px",
      maxHeight: "100vh",
      closable: true,
      autoClose: false,
      draggable: true,
      scrollable: true,
      cls:"resize",
      stateId: PERSISTENCE_STATE_KEYS.aboutEditor,
      items: {
        body: {
          type: "container",
          html: about
        }
      }
    };
  }

  editRecord(record, context, otherParams) {
    super.editRecord(record, context, otherParams);
  }
}

SwivuAbout.initClass();

export const SwivuAboutModal = ({ context, onClose, isShow, editorInstance }) => {
  const onShowHandler = useCallback((editor, otherParams = {}) => {
    editor.project = context.project;
    editor.editRecord(null, context, otherParams);
    editorInstance.editorRef = editor;
  }, [context, editorInstance]);

  return (
    <SwivuModal
      widgetType={SwivuAbout.type}
      isShow={isShow}
      onHide={onClose}
      onShow={onShowHandler}
    />
  );
};
